const filterClientsUseCase = ({ clients, textSearch, limit }) => {
    return clients.filter(client => {
        if (!client.id) {
            return false
        }
        
        if (!textSearch || textSearch.trim() === "") {
            return true
        }

        const texts = textSearch.trim().toLowerCase().split(" ")
        const adaptData = d => d != null ? String(d).toLowerCase() : ""
        const clientsFields = adaptData(client.name) + adaptData(client.id)
        return texts.every(t => clientsFields.includes(t))
    }).slice(0, limit)
}

export default filterClientsUseCase